import React, { useContext, useEffect, useState } from "react";
import UserContext from "../../../context/UserContext";
import "./SessionTimeout.css";

const SessionTimeout = () => {
  const { user, logoutUser } = useContext(UserContext);
  const [showWarning, setShowWarning] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState("");

  useEffect(() => {
    if (!user) return;

    const SESSION_EXPIRATION_TIME = 24 * 60 * 60 * 1000; // 24 hours
    const WARNING_TIME = 30 * 60 * 1000; // Show warning 30 minutes before expiration

    const checkTimeRemaining = () => {
      const lastActivityTime = localStorage.getItem("lastActivityTime");
      if (lastActivityTime) {
        const timeSinceLastActivity =
          Date.now() - parseInt(lastActivityTime, 10);
        const timeLeft = SESSION_EXPIRATION_TIME - timeSinceLastActivity;

        if (timeLeft <= 0) {
          // Session expired
          logoutUser();
        } else if (timeLeft <= WARNING_TIME) {
          // Show warning
          setShowWarning(true);
          const minutesLeft = Math.ceil(timeLeft / 60000);
          setTimeRemaining(
            `${minutesLeft} minute${minutesLeft !== 1 ? "s" : ""}`,
          );
        } else {
          setShowWarning(false);
        }
      }
    };

    // Check every minute
    const interval = setInterval(checkTimeRemaining, 60000);
    checkTimeRemaining(); // Check immediately

    return () => clearInterval(interval);
  }, [user, logoutUser]);

  const handleStayActive = () => {
    // Update activity time
    localStorage.setItem("lastActivityTime", Date.now().toString());
    setShowWarning(false);
  };

  if (!showWarning) return null;

  return (
    <div className="session-timeout-overlay">
      <div className="session-timeout-modal">
        <div className="session-icon">⏱️</div>
        <h3>Session Expiring Soon</h3>
        <p>Your session will expire in {timeRemaining} due to inactivity.</p>
        <button onClick={handleStayActive} className="stay-active-button">
          Stay Logged In
        </button>
      </div>
    </div>
  );
};

export default SessionTimeout;
